import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ScheduleMasterItem } from '../../../../api/model';
import Modal from '../../../modules/Modal';

type Props = {
  /* eslint react/require-default-props: 0 */
  scheduleMaster?: ScheduleMasterItem;
  open: boolean;
  onClose: () => void;
  setFormValues: (params: ScheduleMasterItem) => void;
  append?: (params: ScheduleMasterItem) => void;
};
function MasterScheduleSubFormModal({ open, onClose, setFormValues, scheduleMaster, append }: Props) {
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  const { register, getValues } = useForm<ScheduleMasterItem>({
    defaultValues: scheduleMaster || {
      schedule_master_item_id: undefined,
      master_division_id: 2,
      master_division: 'サブ',
      display_fmc_new_om: 1,
      display_fmc_new_dom: 1,
      display_fmc_new_webom: 1,
      display_fmc_new_translation: 1,
      display_mmc_ymc_om: 1,
      display_mmc_ymc_dom: 1,
      display_mmc_ymc_webom: 1,
      display_mmc_ymc_translation: 1,
      destination: 1,
    },
  });

  const handleSubmit = () => {
    if (scheduleMaster) {
      setFormValues(getValues());
    } else if (append) {
      append(getValues());
    }
    handleClose();
  };

  return (
    <Modal active={open} additionalClassName="popupfr800" displayCloseButton onClose={handleClose}>
      <div className="popupfr popupfr1030">
        <div className="pop-tablefr1">
          <div>
            <table>
              <tbody>
                <tr>
                  <th>
                    <label htmlFor="ip85-1">分類</label>
                  </th>
                  <td>{getValues('master_division')}</td>
                </tr>
                <tr>
                  <th>
                    <label htmlFor="ip85-2">{t('マイルストーン')}</label>
                  </th>
                  <td>
                    <input type="text" {...register('milestone')} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <table>
              <tbody>
                <tr>
                  <th>
                    <label htmlFor="ip85-3">{t('工程')}</label>
                  </th>
                  <td>{getValues('process')}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="fmcfr">
          <div>
            <div className="ttl">{t('FMC,NEW')}</div>
            <div>
              <label htmlFor="display_fmc_new_om">{t('OM')}</label>
              <span className="dropdown">
                <select {...register('display_fmc_new_om')}>
                  <option value="1">◯</option>
                  <option value="0">-</option>
                </select>
              </span>
            </div>
            <div>
              <label htmlFor="display_fmc_new_dom">{t('dOM')}</label>
              <span className="dropdown">
                <select {...register('display_fmc_new_dom')}>
                  <option value="1">◯</option>
                  <option value="0">-</option>
                </select>
              </span>
            </div>
            <div>
              <label htmlFor="display_fmc_new_webom">{t('WebOM')}</label>
              <span className="dropdown">
                <select {...register('display_fmc_new_webom')}>
                  <option value="1">◯</option>
                  <option value="0">-</option>
                </select>
              </span>
            </div>
            <div>
              <label htmlFor="display_fmc_new_translation">{t('翻訳')}</label>
              <span className="dropdown">
                <select {...register('display_fmc_new_translation')}>
                  <option value="1">◯</option>
                  <option value="0">-</option>
                </select>
              </span>
            </div>
          </div>
          <div>
            <div className="ttl">{t('MMC,YMC')}</div>
            <div>
              <label htmlFor="display_mmc_ymc_om">{t('OM')}</label>
              <span className="dropdown">
                <select {...register('display_mmc_ymc_om')}>
                  <option value="1">◯</option>
                  <option value="0">-</option>
                </select>
              </span>
            </div>
            <div>
              <label htmlFor="display_mmc_ymc_dom">{t('dOM')}</label>
              <span className="dropdown">
                <select {...register('display_mmc_ymc_dom')}>
                  <option value="1">◯</option>
                  <option value="0">-</option>
                </select>
              </span>
            </div>
            <div>
              <label htmlFor="display_mmc_ymc_webom">{t('WebOM')}</label>
              <span className="dropdown">
                <select {...register('display_mmc_ymc_webom')}>
                  <option value="1">◯</option>
                  <option value="0">-</option>
                </select>
              </span>
            </div>
            <div>
              <label htmlFor="display_mmc_ymc_translation">{t('翻訳')}</label>
              <span className="dropdown">
                <select {...register('display_mmc_ymc_translation')}>
                  <option value="1">◯</option>
                  <option value="0">-</option>
                </select>
              </span>
            </div>
          </div>
        </div>

        <h3 className="notif">{t('通知')}</h3>

        <div className="pop-tablefr1">
          <div>
            <table>
              <tbody>
                <tr>
                  <th>
                    <label htmlFor="ip85-4">{t('タイミング')}</label>
                  </th>
                  <td className="ktmg">
                    <span>{t('既定のタイミング')}</span>
                    <input type="number" {...register('notification_timing')} />
                  </td>
                </tr>
                <tr>
                  <th>
                    <label htmlFor="dp85-9">{t('送付先')}</label>
                  </th>
                  <td>
                    {' '}
                    <span className="dropdown kisyutantou">
                      <select {...register('destination')}>
                        <option value="1">{t('機種担当')}</option>
                        <option value="2">{t('原作推進担当')}</option>
                        <option value="3">{t('情報収集担当')}</option>
                        <option value="4">{t('技術情報担当')}</option>
                        <option value="5">{t('確認依頼者')}</option>
                        <option value="6">{t('承認依頼者')}</option>
                      </select>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="threadfr2 mb20">
          <label htmlFor="message">{t('メッセージ')}</label>
          <div>
            <textarea id="message" rows={10} cols={33} {...register('message')} />
          </div>
        </div>
        <div className="messagead">
          <p>{t('***にすると、***の部分はマイルストーン名に置換されます。')}</p>
        </div>
        <div className="btnfr btnfr2 mb0 mt0">
          <div>
            <span className="btn2 btnbg-g mr10" onClick={() => handleClose()}>
              <span className="modal-close2">{t('キャンセル')}</span>
            </span>
            <span>
              <input type="submit" value="OK" className="btn1 lsp1" onClick={() => handleSubmit()} />
            </span>{' '}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export { MasterScheduleSubFormModal };
